/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PersonifyExchangeTokenRequest } from '../models/PersonifyExchangeTokenRequest';
import type { SuccessLoginResponse } from '../models/SuccessLoginResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PersonifySsoControllerService {

    /**
     * Exchanges the single-use single sign-on token for a refresh and an access token.
     * @param requestBody
     * @returns SuccessLoginResponse OK
     * @throws ApiError
     */
    public static exchangePersonifySsoToken(
        requestBody: PersonifyExchangeTokenRequest,
    ): CancelablePromise<SuccessLoginResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/integrations/personify/sso/exchange',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `The client is not authorized to perform the action. The \`code\`, \`message\`, and \`data\` fields may provide more information about the reason of the error.`,
                404: `The requested entity was not found, or the client has no permission to access the entity.`,
                500: `An unexpected error has occurred.`,
            },
        });
    }

    /**
     * Starts the Personify Health single sign-on by redirecting the member to Personify.
     * @param target
     * @returns void
     * @throws ApiError
     */
    public static startPersonifySso(
        target?: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/integrations/personify/sso/start',
            query: {
                'target': target,
            },
            errors: {
                302: `Redirect to Personify's authorization endpoint`,
                400: `Bad Request`,
                401: `The client is not authorized to perform the action. The \`code\`, \`message\`, and \`data\` fields may provide more information about the reason of the error.`,
                404: `The requested entity was not found, or the client has no permission to access the entity.`,
                500: `An unexpected error has occurred.`,
            },
        });
    }

    /**
     * Receives Personify's authorization code and redirects the member back into 9amHealth.
     * @param state
     * @param clientIpAddress
     * @param code
     * @param error
     * @returns void
     * @throws ApiError
     */
    public static completePersonifySso(
        state: string,
        clientIpAddress: string,
        code?: string,
        error?: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/integrations/personify/sso/callback',
            query: {
                'code': code,
                'state': state,
                'error': error,
                'clientIpAddress': clientIpAddress,
            },
            errors: {
                302: `Redirect carrying a single-use exchange token`,
                400: `Bad Request`,
                401: `The client is not authorized to perform the action. The \`code\`, \`message\`, and \`data\` fields may provide more information about the reason of the error.`,
                404: `The requested entity was not found, or the client has no permission to access the entity.`,
                500: `An unexpected error has occurred.`,
            },
        });
    }

}
